export const renewal_frequency = [
	{ label: 'Annually', value: 'ANNUALLY' },
	{ label: 'Every N Years', value: 'EVERY_N_YEARS' },
];
